/* Thoson contact page (oct 2026). Seccion: sections/thx-contact.liquid
   1. Boton "Copy email": copia el correo y cambia el texto 2 segundos. Si el navegador no deja
      copiar, abre el correo.
   2. Rastreo: si el campo va vacio, no manda "?order=" y abre ParcelPanel limpio. */
(function () {
  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.top = '-1000px';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      document.body.removeChild(ta);
      if (ok) { resolve(); } else { reject(); }
    });
  }

  function init(root) {
    var buttons = root.querySelectorAll('[data-thx-ct-copy]');
    Array.prototype.forEach.call(buttons, function (btn) {
      if (btn.getAttribute('data-thx-ct-ready')) return;
      btn.setAttribute('data-thx-ct-ready', '1');
      var label = btn.querySelector('[data-thx-ct-copy-label]');
      var original = label ? label.textContent : '';
      var timer = null;
      btn.addEventListener('click', function () {
        var email = btn.getAttribute('data-thx-ct-copy');
        copyText(email).then(function () {
          if (label) label.textContent = btn.getAttribute('data-thx-ct-copied') || original;
          btn.classList.add('is-copied');
          clearTimeout(timer);
          timer = setTimeout(function () {
            if (label) label.textContent = original;
            btn.classList.remove('is-copied');
          }, 2000);
        }).catch(function () {
          window.location.href = 'mailto:' + email;
        });
      });
    });

    var forms = root.querySelectorAll('[data-thx-ct-track]');
    Array.prototype.forEach.call(forms, function (form) {
      if (form.getAttribute('data-thx-ct-ready')) return;
      form.setAttribute('data-thx-ct-ready', '1');
      form.addEventListener('submit', function () {
        var input = form.querySelector('input[name="order"]');
        if (!input) return;
        input.value = input.value.trim();
        if (!input.value) input.disabled = true;
      });
    });
  }

  /* Al volver atras desde ParcelPanel el campo no puede quedar desactivado. */
  window.addEventListener('pageshow', function () {
    var inputs = document.querySelectorAll('[data-thx-ct-track] input[name="order"]');
    Array.prototype.forEach.call(inputs, function (input) { input.disabled = false; });
  });

  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
